module.exports = __webpack_public_path__ + "img/Img36_Pointe-a-Calliere.68c77994.jpg";